<template>
  <div>
    <main class="content content--narrow" v-if="showFBAccess">

      <figure v-if="manager !== false" class="content__avatar content__avatar--company">
        <img v-if="manager.logo" :src="manager.logo">
      </figure>

      <div class="content__heading content__heading--center">
        <h1>
          <i class="icon--link"></i> {{ $t('fusebox.request_to_access') }}
        </h1>
      </div>

      <section class="content--boxed" v-for="request in requests" :key="request.uuid">

        <div v-html="$t('general.requesting', [request.fusebox.name, request.company.name])"></div>

        <div class="btn--bar">
          <button @click="$modal.show(
               'accept-confirmation',
             {fusebox: request.fusebox.uuid, accessRequest: request.uuid, type: 1}
             )"
                  type="button" class="btn">
            <i class="icon--link"></i> {{ $t('general.accept') }}
          </button>
          <button type="button"
                  @click="grantRequest({fusebox: request.fusebox.uuid, accessRequest: request.uuid, type: 0})"
                  class="btn btn--secondary">
            <i class="icon--cancel"></i> {{ $t('general.decline') }}
          </button>
        </div>
      </section>

      <section class="content--boxed" v-if="manager !== false">

        <div v-html="$t('general.managed_by', [manager.name])"></div>

        <div class="btn--bar">
          <button @click="$modal.show('revoke-confirmation', {fusebox: managed.uuid})" type="button" class="btn">
            <i class="icon--unlink"></i> {{ $t('general.revoke') }}
          </button>
        </div>
      </section>
    </main>
    <Confirm name="accept-confirmation" @confirmed="grantRequest" action-key="general.accept"/>
    <Confirm name="revoke-confirmation" @confirmed="revokeAccess" action-key="general.revoke"
             title="general.revoke_title" body="general.revoke_body_owner"/>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { errHandler } from '@/helpers'
import Confirm from '@/components/Modal/Confirm'

export default {
  name: 'Access-Index',
  components: {
    Confirm
  },
  async mounted () {
    await this.$store.dispatch('auth/user')
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters('auth', ['requests', 'managed', 'manager']),
    showFBAccess () {
      return this.isRole(this.roles.OWNER.ROLE_OWNER) && (this.requests !== false || this.manager !== false)
    }
  },
  methods: {
    async grantRequest (params) {
      try {
        await this.$store.dispatch('fusebox/grantAccess', params)
        this.$toasted.global.success_message({
          message: params.type === 1 ? this.$t('fusebox.accessAccepted') : this.$t('fusebox.accessDeclined')
        })
        this.$modal.hide('accept-confirmation')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    async revokeAccess (params) {
      try {
        await this.$store.dispatch('fusebox/revokeAccess', params)
        this.$toasted.global.success_message({
          message: this.$t('fusebox.accessRevoked')
        })
        this.$modal.hide('revoke-confirmation')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    }
  }
}
</script>
